import React from 'react';
import { SmallUppercase, SuccessText, AccentBody } from 'scy/text';
import { success, accent } from 'scy/text/styles.mod.scss';
import styles from './styles.mod.scss';

export function SuccessPill(props) {
  return <Pill variant="success" {...props} />;
}

export function AccentPill(props) {
  return <Pill variant="accent" {...props} />;
}

function Pill({ label, text, className, variant }) {
  return !text ? null : (
    <div className={className}>
      {!!label && (
        <SmallUppercase
          className={variant === 'accent' ? accent : success}
          tag="div"
        >
          {label}
        </SmallUppercase>
      )}
      {variant === 'accent' ? (
        <AccentBody className={styles.accentPill}>{text}</AccentBody>
      ) : (
        <SuccessText className={styles.successPill}>{text}</SuccessText>
      )}
    </div>
  );
}
